import { render, staticRenderFns } from "./notSetIcon.vue?vue&type=template&id=2f682e3c&scoped=true"
import script from "./notSetIcon.vue?vue&type=script&lang=js"
export * from "./notSetIcon.vue?vue&type=script&lang=js"
import style0 from "./notSetIcon.vue?vue&type=style&index=0&id=2f682e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f682e3c",
  null
  
)

export default component.exports